import React from 'react';

interface TrainingStatusLineProps {
  /** Tailwind background (and animation) classes for the dot. */
  dotClassName: string;
  testId?: string;
  children: React.ReactNode;
}

/**
 * One status line of the live call's "Audio Settings" panel: a small dot and
 * a text-xs caption. Every training detail in that panel uses this shape.
 */
export const TrainingStatusLine: React.FC<TrainingStatusLineProps> = ({ dotClassName, testId, children }) => (
  <div className="flex items-center space-x-1" data-testid={testId}>
    <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dotClassName}`} />
    <span className="text-xs text-ink-secondary">{children}</span>
  </div>
);

export default TrainingStatusLine;
